import { useQuery, UseQueryResult } from '@tanstack/react-query';
import ReviewApiV2 from '../../../../../../lib/api/cs/review/ReviewApiV2';
import { QueryOptions } from '../../../../../../types/query/useQuery';
import { ReviewFindResponseBodyDto } from '../../../../../../types/api/reviews';
import csReviewToastMsg from '../../../../../../constants/service/toastMsg/csReviewToastMsg';
import { REVIEW } from '../../../../../../constants/queryKeys';
import { ReviewListRequestType, ReviewListResponseType } from '../../types/ReviewListType';

type UseRelatedTagListQuery<SelectResultType> = {
  params: ReviewListRequestType;
  options?: QueryOptions<ReviewFindResponseBodyDto, unknown, SelectResultType> & {
    meta?: {
      successCallback?: (data: ReviewFindResponseBodyDto) => void;
    };
  };
};

export const useFetchReviewsQuery = (
  payload: UseRelatedTagListQuery<ReviewListResponseType>,
): UseQueryResult<ReviewListResponseType, unknown> => {
  const { params, options } = payload;
  return useQuery<ReviewFindResponseBodyDto, unknown, ReviewListResponseType>(
    [...REVIEW.LIST, params],
    () => ReviewApiV2.fetchReviewList(params),
    {
      ...options,
      select: (data: ReviewFindResponseBodyDto): ReviewListResponseType => {
        return {
          totalCount: data.totalCount,
          reviews: data.reviews.map((review) => ({
            ...review,
            hasAttachments: review.reviewAttachments.length > 0,
          })),
        };
      },
      keepPreviousData: true,
      meta: {
        onSuccess: (data: ReviewFindResponseBodyDto) => {
          if (options?.meta?.successCallback) {
            options.meta.successCallback(data);
          }
        },
        errorMessage: csReviewToastMsg.GET_REVIEW_LIST_REQUEST_ERROR,
      },
    },
  );
};
